import { DateTime } from 'luxon';
import { useExperienceState } from 'shared/features/experience-state';
import { EHR_LAUNCH_APPOINTMENT_DATE } from '../../config';
export var useCompassScopeCreated = function () {
    var experienceState = useExperienceState().data;
    if (experienceState) {
        return experienceState.onboard_date ? DateTime.fromISO(experienceState.onboard_date).toFormat('MM/dd/yyyy') : EHR_LAUNCH_APPOINTMENT_DATE;
    }
    return null;
};
